import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmUpload, IconX } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm';
import style from './page-upload.module.scss';

export const PageUpload: React.FC = () => {
  const label = useLabel();
  const upload = useLlm(state => state.upload);
  const mimeTypes = useLlm(state => state.mimeTypes);
  const { removeFile, addFile, hasUploadSupport } = useLlm(state => state.actions);
  const hasUpload = hasUploadSupport();
  return hasUpload && (
    <>
      <div className={getClassNames(style.upload)}>
        <div className={getClassNames(style.ui)}
          aria-label={label('llm.upload')}
        >
          <IconLlmUpload />
        </div>
        <input className={getClassNames(style.input)} type="file" id="file-input" accept={mimeTypes} onChange={addFile} />
      </div>
      {upload && (
        <button
          type="button"
          className={getClassNames(style.file)}
          onClick={() => removeFile()}
          title={upload.file.name}
        >
          <span>{upload.file.name}</span>
          <IconX />
          <img src={upload.base64} alt="" />
        </button>
      )}
    </>
  );
};
